import { EndUserTaskListItem } from 'components/core/end-user-task-list/EndUserTaskList'
import { EndUserDashboardSection } from 'components/pages/end-user-dashboard/EndUserDashboardSection'
import { GrantTaskType } from 'components/pages/task/type'
import { TaskValue } from 'lib/actions/task'
import { UserContext } from 'lib/context/app'
import { unsafeRoute } from 'lib/routes'
import { TaskSearchCountRequest, TaskSearchRequest } from 'pbts/c1/api/task/v1/search'
import { TaskState } from 'pbts/c1/api/task/v1/task'
import { FC, useContext } from 'react'
import { useIntl } from 'react-intl'
import { getTaskSearchCountApi, tasksSearchApi } from 'redux_toolkit/tasks'

export const EndUserDashboardMyRequests: FC = () => {
    const intl = useIntl()
    const { user } = useContext(UserContext)
    const userId = user?.id

    const filter = TaskSearchRequest.create({
        subjectIds: [userId],
        taskTypes: [GrantTaskType],
        taskStates: [TaskState.OPEN],
    })

    return <EndUserDashboardSection<TaskValue, TaskSearchRequest, TaskSearchCountRequest>
        title={intl.formatMessage({
            id: 'end_user_dashboard_my_requests_title',
            defaultMessage: 'Your open requests',
        })}
        seeAllHref={unsafeRoute(`/requests/my-requests?userId=${userId}`)}
        seeAllLabel={(count): string => (count === 1
            ? intl.formatMessage({
                id: 'end_user_dashboard_my_requests_see_all_one',
                defaultMessage: 'See open request',
            })
            : intl.formatMessage({
                id: 'end_user_dashboard_my_requests_see_all',
                defaultMessage: 'See all {count} open requests',
            }, { count }))}
        ListItemComponent={EndUserTaskListItem}
        getDataHook={tasksSearchApi.useSearch}
        getDataRequest={{
            ...filter,
            expandMask: { paths: ['*'] },
        }}
        getCountHook={getTaskSearchCountApi.useSearchCount}
        getCountRequest={TaskSearchCountRequest.create({ filter })}
        invalidateHook={tasksSearchApi.useInvalidateSearch}
        showIsLoading
    />
}
